var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var _window = window;

        _objectDestructuringEmpty(_window);

        var RoomsDesktop = function () {
            function RoomsDesktop(params) {
                _classCallCheck(this, RoomsDesktop);

                this.modal = window.modal;
                this.roomsSwiper = null;
                this.roomImagesSwiper = null;

                this.rooms = params.rooms ? params.rooms : [];

                this.init();

                this.handlers();
            }

            _createClass(RoomsDesktop, [{
                key: "init",
                value: function init() {
                    var _this = this;

                    this._initRoomsSwiper();
                    this.panel = document.getElementById('hotelRoomsPanel');
                    if (this.panel) {
                        var navigation = this.panel.querySelector('[data-room-navigation]');
                        this.rooms.forEach(function (room) {
                            var button = document.createElement('button');
                            button.type = 'button';
                            button.className = 'hotel-rooms-panel__tab';
                            button.dataset.roomId = room.id;
                            var image = document.createElement('img');
                            image.src = room.photos && room.photos.length ? room.photos[0] : '/x-assets/img/no-image.svg';
                            image.alt = '';
                            image.loading = 'lazy';
                            button.appendChild(image);
                            var label = document.createElement('span');
                            label.textContent = room.name;
                            button.appendChild(label);
                            var source = document.querySelector('.js-toggle-all-room-modal[data-id="' + room.id + '"] .room-item__area');
                            if (source) label.appendChild(source.cloneNode(true));
                            button.addEventListener('click', function () {
                                if (String(_this.activeRoomId) === String(room.id)) return;
                                if (window.brxTracking) window.brxTracking.sendAnalyticsEvent('hotel_room_change', Object.assign({}, window.app && window.app.pageParams, { context: 'hotel', room_id: room.id }));
                                _this._renderModalContent(room.id);
                                _this.roomImagesSwiper && _this.roomImagesSwiper.update();
                            });
                            navigation.appendChild(button);
                        });
                    } else {
                        document.body.appendChild(this._createHiddenWrapper());
                    }
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this2 = this;

                    $event.on('click', '.js-toggle-all-room-modal', function (event, element) {
                        var roomId = element.dataset.id;
                        _this2._renderModalContent(roomId);
                        _this2.openModal();

                        window.brxTracking.sendAnalyticsEvent('click_hotel_room_type');
                    });
                }
            }, {
                key: "openModal",
                value: function openModal() {
                    var _this3 = this;

                    if (!this.modal || typeof this.modal.open !== 'function') return;

                    this.modal.open({
                        header: this.panel ? null : { title: '' },
                        content: { htmlDetachSelectorId: this.panel ? 'hotelRoomsPanel' : 'hotelRoomDetailDesktop' },
                        parentCssClass: this.panel ? 'hotel-reviews-panel-modal hotel-rooms-panel-modal' : 'hotel-rooms-desktop-modal',
                        footer: null,
                        type: this.panel ? 'full' : 'floating',
                        onBeforeClose: function onBeforeClose() {
                            //QS('#hotelPhotosCategories .category-item[data-id="0"]').click();
                        },
                        onAfterShow: function onAfterShow() {
                            if (_this3.roomImagesSwiper) {
                                _this3.roomImagesSwiper.update();
                                _this3.roomImagesSwiper.slideTo(0, 0);
                            }
                        }
                    });
                }
            }, {
                key: "_initRoomsSwiper",
                value: function _initRoomsSwiper() {
                    this.roomsSwiper = new Swiper('#hotelRoomsSlider', {
                        freeMode: false,
                        loop: false,
                        slidesPerView: 'auto',
                        spaceBetween: 14,
                        pagination: {
                            el: ".swiper-pagination"
                        },
                        navigation: {
                            nextEl: '.next-room-slider',
                            prevEl: '.prev-room-slider'
                        }
                    });
                }
            }, {
                key: "_createHiddenWrapper",
                value: function _createHiddenWrapper() {
                    var hiddenWrapper = document.createElement('div');
                    hiddenWrapper.classList.add('hide');

                    var content = document.createElement('div');
                    content.id = 'hotelRoomDetailDesktop';

                    hiddenWrapper.appendChild(content);

                    return hiddenWrapper;
                }
            }, {
                key: "_renderModalContent",
                value: function _renderModalContent(roomId) {
                    this.activeRoomId = roomId;
                    if (this.roomImagesSwiper) {
                        this.roomImagesSwiper.destroy(true, true);
                        this.roomImagesSwiper = null;
                    }
                    if (this.panel) {
                        this.panel.querySelectorAll('[data-room-id]').forEach(function (button) {
                            button.setAttribute('aria-current', String(button.dataset.roomId === String(roomId)));
                        });
                    }
                    var container = QS('#hotelRoomDetailDesktop');
                    container.innerHTML = '';

                    var currentRoom = this.rooms.find(function (room) {
                        return room.id === +roomId;
                    });

                    var titleText = currentRoom.name;
                    if (titleText) {
                        var title = document.createElement('div');
                        title.className = 'room-details__name';
                        title.textContent = titleText;
                        container.appendChild(title);
                    }

                    var wrapper = document.createElement('div');
                    wrapper.classList.add('room-details-wrapper');

                    var photos = Array.isArray(currentRoom.photos) ? currentRoom.photos.filter(Boolean) : [];
                    if (photos.length) {
                        wrapper.appendChild(this._renderRoomImageSlider(photos));
                    } else {
                        wrapper.classList.add('room-details-wrapper--no-images');
                    }

                    wrapper.appendChild(this._renderRoomDetails(currentRoom));
                    container.appendChild(wrapper);

                    if (this.panel) {
                        var details = wrapper.querySelector('.room-details');
                        var heading = container.querySelector('.room-details__name');
                        if (heading) details.prepend(heading);
                        var amenities = document.createElement('div');
                        amenities.className = 'hotel-rooms-panel__amenities';
                        details.querySelectorAll('.room-details__section').forEach(function (section) {
                            return amenities.appendChild(section);
                        });
                        if (amenities.children.length) container.appendChild(amenities);
                        var modalContent = this.panel.closest('.modal2-content');
                        if (modalContent) modalContent.scrollTop = 0;
                    }

                    return container;
                }
            }, {
                key: "_renderRoomDetails",
                value: function _renderRoomDetails(currentRoom) {
                    var root = document.createElement('div');
                    root.className = 'room-details';

                    var norm = function norm(v) {
                        if (v === null || v === undefined) {
                            return '';
                        }
                        return String(v).trim();
                    };

                    var low = function low(v) {
                        return norm(v).toLowerCase();
                    };

                    var isNo = function isNo(v) {
                        var s = low(v);
                        return s === 'нет' || s === 'no' || s === 'false' || s === '0';
                    };

                    var isPaidFlag = function isPaidFlag(v) {
                        var s = low(v);
                        return s === 'платно' || s === 'бесплатно';
                    };

                    /* ---------- Описание ---------- */
                    var descText = norm(currentRoom.description);
                    if (descText) {
                        var desc = document.createElement('div');
                        desc.className = 'room-details__description';
                        desc.textContent = descText;
                        root.appendChild(desc);
                    }

                    /* ---------- Сервисы ---------- */
                    var services = Array.isArray(currentRoom.services) ? currentRoom.services : [];
                    var filteredServices = services.filter(function (s) {
                        if (!s) return false;
                        var v = norm(s.value);
                        if (!v) return false;
                        if (isNo(v)) return false;
                        return true;
                    });

                    if (filteredServices.length) {
                        var section = document.createElement('div');
                        section.className = 'room-details__section';

                        var h = document.createElement('div');
                        h.className = 'room-details__section-title';
                        h.textContent = 'Удобства';
                        section.appendChild(h);

                        var ul = document.createElement('ul');
                        ul.className = 'room-details__list';

                        filteredServices.forEach(function (s) {
                            var li = document.createElement('li');
                            li.className = 'room-details__item';

                            var name = document.createElement('span');
                            name.className = 'room-details__item-name';
                            name.textContent = norm(s.name);
                            li.appendChild(name);

                            var v = norm(s.value);
                            if (isPaidFlag(v)) {
                                var meta = document.createElement('span');
                                meta.className = 'room-details__item-meta';
                                if (low(v) === 'платно') meta.classList.add('room-details__item-meta--paid');
                                meta.textContent = v;
                                li.appendChild(meta);
                            }

                            ul.appendChild(li);
                        });

                        section.appendChild(ul);
                        root.appendChild(section);
                    }

                    /* ---------- Доп. услуги ---------- */
                    var additional = currentRoom.additionalServices;

                    if (additional && !Array.isArray(additional) && (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === 'object') {
                        additional = Object.values(additional);
                    }

                    if (Array.isArray(additional) && additional.length) {
                        var _section = document.createElement('div');
                        _section.className = 'room-details__section';

                        var _h = document.createElement('div');
                        _h.className = 'room-details__section-title';
                        _h.textContent = 'Дополнительные услуги';
                        _section.appendChild(_h);

                        var _ul = document.createElement('ul');
                        _ul.className = 'room-details__list';

                        additional.forEach(function (text) {
                            var t = norm(text);
                            if (!t) return;

                            var li = document.createElement('li');
                            li.className = 'room-details__item';
                            li.textContent = t;
                            _ul.appendChild(li);
                        });

                        _section.appendChild(_ul);
                        root.appendChild(_section);
                    }

                    return root;
                }
            }, {
                key: "_renderRoomImageSlider",
                value: function _renderRoomImageSlider(photos) {
                    var list = Array.isArray(photos) ? photos : [];

                    // Создаём DOM контейнер (он будет жить в modal content)
                    var root = document.createElement('div');
                    root.className = 'room-images';

                    root.innerHTML = '<div class="swiper room-images__swiper" id="roomImagesSwiper">' + '<div class="swiper-wrapper"></div>' + '<div class="swiper-pagination room-images__pagination"></div>' + '<div class="room-images__nav room-images__prev"></div>' + '<div class="room-images__nav room-images__next"></div>' + '</div>';

                    var swiperEl = root.querySelector('#roomImagesSwiper');
                    var wrapper = swiperEl.querySelector('.swiper-wrapper');

                    // --- вставляем слайды (всегда)
                    var slidesHtml = '';
                    for (var i = 0; i < list.length; i++) {
                        var src = list[i];
                        if (!src) continue;

                        slidesHtml += '<div class="swiper-slide room-images__slide">' + '<img class="room-images__img" src="' + src + '" loading="lazy" alt="Room photo">' + '</div>';
                    }

                    wrapper.innerHTML = slidesHtml;

                    this.roomImagesSwiper = new Swiper(swiperEl, {
                        loop: false,
                        slidesPerView: 1,
                        spaceBetween: 8,
                        pagination: {
                            el: swiperEl.querySelector('.room-images__pagination'),
                            clickable: true
                        },
                        navigation: {
                            nextEl: swiperEl.querySelector('.room-images__next'),
                            prevEl: swiperEl.querySelector('.room-images__prev')
                        },
                        preloadImages: false,
                        lazy: true
                    });

                    return root;
                }
            }]);

            return RoomsDesktop;
        }();

        window.RoomsDesktop = RoomsDesktop;
    }, {}] }, {}, [1]);